<script>
  import {Pie} from "vue-chartjs";
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  export default {
    extends: Pie,
    name: "AreaChart",
    computed: {
      ...mapGetters(['area_chart']),
    },
    mounted() {
      this.renderAreaChart()
    },
    methods: {
      renderAreaChart() {
        let data = this.area_chart.area_data || {};

        this.renderChart(
          {
            labels: (data.labels || []),
            datasets: [
              {
                backgroundColor: ['#21CF98', '#51BCDA', '#EF8157', '#ff6666', '#cc99ff', '#668cff', '#66d9ff', '#66ffff', '#66ffb3', '#8cff66', '#d9ff66', '#ffff66', '#ffb366', '#ff8c66', '#ff6666', '#b3b3b3',"#ffb3b3", '#ecb3ff', '#b3b3ff', '#b3ecff', '#b3ffec', '#b3ffc6', '#d9ffb3'],
                data: (data.data || []),
              }
            ],
          },
          {
            legend: {
              position: 'top'
            },
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: function(tooltipItem, data) {
                  var dataset = data.datasets[tooltipItem.datasetIndex];
                  var labels = data.labels
                  var total = dataset.data.flat().reduce(function(previousValue, currentValue, currentIndex, array) {
                    return previousValue + currentValue;
                  });
                  var current_Label = labels[tooltipItem.index]
                  var currentValue = dataset.data[tooltipItem.index];
                  var precentage = Math.floor(((currentValue/total) * 100)+0.5);
                  return  current_Label + ": "+precentage + "% " + "(" + currentValue + ")";
                }
              }
            }
          },
        );
      }
    }
  }
</script>

<style scoped>

</style>
